import { supabase } from '../lib/supabase';

export const realtimeService = {
  // Subscribe to project changes
  subscribeToProjects(callback) {
    const channel = supabase?.channel('projects_changes')?.on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'projects'
        },
        (payload) => {
          callback(payload);
        }
      )?.subscribe();

    return channel;
  },

  // Subscribe to project phases changes
  subscribeToPhases(projectId, callback) {
    const channel = supabase?.channel(`phases_${projectId}`)?.on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'project_phases',
          filter: projectId ? `project_id=eq.${projectId}` : undefined
        },
        (payload) => {
          callback(payload);
        }
      )?.subscribe();

    return channel;
  },

  // Subscribe to all phases (for admin views)
  subscribeToAllPhases(callback) {
    const channel = supabase?.channel('all_phases_changes')?.on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'project_phases'
        },
        (payload) => {
          callback(payload);
        }
      )?.subscribe();

    return channel;
  },

  // Subscribe to profit calculations
  subscribeToCalculations(callback) {
    const channel = supabase?.channel('calculations_changes')?.on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'profit_calculations'
        },
        (payload) => {
          callback(payload);
        }
      )?.subscribe();

    return channel;
  },

  // Subscribe to user profile changes
  subscribeToUserProfiles(callback) {
    const channel = supabase?.channel('user_profiles_changes')?.on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'user_profiles'
        },
        (payload) => {
          callback(payload);
        }
      )?.subscribe();

    return channel;
  },

  // Subscribe to tax settings changes
  subscribeToTaxSettings(callback) {
    const channel = supabase?.channel('tax_settings_changes')?.on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'tax_settings'
        },
        (payload) => {
          callback(payload);
        }
      )?.subscribe();

    return channel;
  },

  // Subscribe to IRRF tax brackets changes
  subscribeToIrrfBrackets(callback) {
    const channel = supabase?.channel('irrf_brackets_changes')?.on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'irrf_tax_brackets'
        },
        (payload) => {
          callback(payload);
        }
      )?.subscribe();

    return channel;
  },

  // Unsubscribe from a channel
  unsubscribe(channel) {
    if (channel) {
      supabase?.removeChannel(channel);
    }
  },

  // Unsubscribe from multiple channels
  unsubscribeAll(channels) {
    if (channels && Array.isArray(channels)) {
      channels?.forEach(channel => {
        if (channel) {
          supabase?.removeChannel(channel);
        }
      });
    }
  }
};
